import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { MdArrowForward, MdTrendingUp, MdVerified, MdSecurity } from "react-icons/md";
import heroImg from "../assets/banner.jpg"; // Your primary corporate photography asset

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <section className="finance-premium-hero">
      
      {/* ===== FULL-BLEED ARCHITECTURAL BACKGROUND ENGINE ===== */}
      <div className="hero-spatial-backdrop">
        {/* Full-surface premium corporate textured canvas */}
        <div className="hero-canvas-texture-overlay" />
        
        {/* Volumetric ambient lighting maps */}
        <div className="ambient-glow glow-primary" />
        <div className="ambient-glow glow-gold" />
        
        {/* Uniform base corporate layout micro-dots */}
        <div className="dot-matrix-layer matrix-global-underlay" />
        
        {/* ADVANCED: Left-side 3D Wavy Dot Grid System (Behind the typography) */}
        <div className="dot-matrix-layer matrix-left-3d-wave-mesh">
          <div className="wave-ripple-node node-1" />
          <div className="wave-ripple-node node-2" />
        </div>
        
        {/* Right-side perspective mathematical projection grid */}
        <div className="dot-matrix-layer matrix-right-perspective" />
        
        {/* Clean geometric grid structural accent rule */}
        <div className="geometric-linear-accent" />
      </div>

      <div className="container-fluid position-relative h-100 hero-z-index premium-hero-container">
        <div className="row align-items-center h-100">
          
          {/* LEFT SIDE: Value Propositions, Accreditation & Dynamic Wave Canvas */}
          <div className="col-xl-5 col-lg-6 col-12 hero-text-engine" data-aos="fade-right">
            
            <div className="premium-badge-container">
              <span className="nbaa-certified-tag">
                <MdVerified className="tag-icon-lead" /> Registered NBAA Member Firm
              </span>
            </div>
            
            <h1 className="hero-corporate-title">
              Strategic Audit, Compliance & <span className="gold-gradient-text">Tax Engineering</span>
            </h1>
            
            <p className="hero-corporate-lead">
              Blessing Management Consultancy delivers high-quality statutory auditing, financial reporting, 
              and corporate tax optimization for growing businesses and mid-sized enterprises across Tanzania.
            </p>
            
            <div className="hero-interactive-row">
              <button 
                className="hero-action-btn-filled" 
                onClick={() => appContext.navTo({ item: "services" })}
              >
                <span>Our Advisory Services</span>
                <MdArrowForward className="btn-motion-arrow" />
              </button>
              
              <button 
                className="hero-action-btn-outlined" 
                onClick={() => appContext.navTo({ item: "contact" })}
              >
                <span>Free Consultation</span>
              </button>
            </div>

            {/* Geographical Footprint Indicators */}
            <div className="hero-national-footprint mDesktopOnly">
              <div className="footprint-pill">
                <span className="pill-dot" /> <strong>Dar es Salaam</strong>
              </div>
              <div className="footprint-pill">
                <span className="pill-dot" /> <strong>Dodoma</strong>
              </div>
              <div className="footprint-pill">
                <span className="pill-dot" /> <strong>Morogoro</strong>
              </div>
            </div>

          </div>

          {/* RIGHT SIDE: Maximized Premium Focal Corporate Image Frame Stack */}
          <div className="col-xl-7 col-lg-6 col-12 hero-graphic-engine" data-aos="fade-left" data-aos-delay="150">
            <div className="hero-composite-frame-maximized">
              
              {/* Geometric backing border wireframe layout */}
              <div className="frame-backing-geometry-large" />
              
              {/* Enlarged high-impact image frame wrapper wrapper */}
              <div className="image-frame-wrapper-large mShadow3">
                <img 
                  src={heroImg} 
                  alt="Blessing Management Consultancy - Executive Corporate Financial Operations" 
                  className="hero-premium-img-large" 
                />
                {/* Embedded corporate overlay shading for rich dark integrated blend */}
                <div className="image-premium-inner-shading" />
              </div>

              {/* Floating Performance Indicator Card - Metric Left */}
              <div className="floating-metric-widget-large widget-left-large mShadow3">
                <div className="widget-icon-frame stripe-gold">
                  <MdTrendingUp />
                </div>
                <div className="widget-body">
                  <h5>Fair Fixed Fees</h5>
                  <p>Transparent fiscal commitments with zero corporate surprises.</p>
                </div>
              </div>

              {/* Floating Performance Indicator Card - Metric Right */}
              <div className="floating-metric-widget-large widget-right-large mShadow3">
                <div className="widget-icon-frame stripe-navy">
                  <MdSecurity />
                </div>
                <div className="widget-body">
                  <h5>High Quality</h5>
                  <p>Certified Public Accountants in Public Practice.</p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}